import BaseReportPDFPreviewLightbox from "../pdf/PDFPreviewLightbox"
import PDFPreviewLightboxController from "./PDFPreviewLightboxController"

export default class PDFPreviewLightbox extends BaseReportPDFPreviewLightbox {

    createPDFLightboxController({lightBoxEl, titleEl, popupId, eventNamespace}) {
        return new PDFPreviewLightboxController().init({
            lightBoxEl: lightBoxEl,
            titleEl: titleEl,
            popupId: popupId,
            eventNamespace: eventNamespace,
            productSettingsValidator: new ATProductSettingsValidator(),
            reportRightsValidator: new ATReportRightsValidator(),
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/estimatedVsActualReport/PDFPreviewLightbox.js